<template>
  <div
    class="flex flex-col items-center justify-center w-full pb-20 bg-[#F2F6FA]"
  >
    <section
      class="flex flex-col items-center w-full justify-center xl:w-[1285px]"
    >
      <div
        class="flex flex-col items-center justify-center w-full h-full pb-20"
      >
        <section
          class="flex flex-col items-center w-full justify-center xl:w-[100%]"
        >
          <div
            class="w-full xl:w-[100%] flex justify-center items-center gap-4"
          >
            <div class="w-full bg-white rounded-b-xl">
              <div
                class="flex flex-col justify-between w-full px-5 py-2 mx-auto"
              >
                <div class="flex w-full items-center justify-between">
                  <v-list-item
                    @click="
                      showWelcomePopup = true;
                      showActionsMenu = false;
                    "
                  >
                    <v-list-item-title>Auto Respond Settings</v-list-item-title>
                    <v-icon>mdi-tune</v-icon>
                  </v-list-item>
                </div>
                <v-list-item
                  @click="
                    showResponseLimitDialog = true;
                    showActionsMenu = false;
                  "
                >
                  <v-list-item-title
                    >Response Word Limit Setting</v-list-item-title
                  >
                  <v-icon>mdi-tune</v-icon>
                </v-list-item>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>

    <!-- Location dropdown remains same -->
    <v-dialog v-model="showWelcomePopup" max-width="500px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <span class="text-h6">Auto Respond Setting</span>
          <v-btn icon @click="closePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-checkbox
            v-model="autoRespond"
            @change="updateAutoRespond"
            label="Enable Auto Respond Review"
          ></v-checkbox>

          <!-- Star rating checkboxes -->
          <div v-if="autoRespond" class="ml-3 border-l-2 border-gray-300 pl-2">
            <span class="font-weight-medium d-flex align-center">
              Respond to Star Ratings:
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    color="grey"
                    class="ml-1"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-information
                  </v-icon>
                </template>
                <span>Please select star rating you want auto respond to</span>
              </v-tooltip>
            </span>
            <div class="flex flex-row">
              <v-checkbox
                v-model="autoRespondStarRating"
                value="FIVE"
                @change="updateAutoRespondStarRating"
                label="5 Star"
                class="mr-4"
              ></v-checkbox>
              <v-checkbox
                v-model="autoRespondStarRating"
                value="FOUR"
                @change="updateAutoRespondStarRating"
                label="4 Star"
                class="mr-4"
              ></v-checkbox>
              <v-checkbox
                v-model="autoRespondStarRating"
                value="THREE"
                @change="updateAutoRespondStarRating"
                label="3 Star"
              ></v-checkbox>
            </div>

            <!-- Salutations radio buttons -->
            <div class="mt-4">
              <span class="font-weight-medium d-flex align-center">
                Salutations:
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      small
                      color="grey"
                      class="ml-1"
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-information
                    </v-icon>
                  </template>
                  <span
                    >Please select salutation you want in your review replies
                  </span>
                </v-tooltip>
              </span>
              <v-radio-group
                v-model="selectedSalutation"
                @change="updateSalutations"
                row
              >
                <v-radio label="Sir/Ma'am" value="sir_maam"></v-radio>
                <v-radio label="Dear" value="dear"></v-radio>
                <v-radio label="Ji" value="ji" v-if="country == 'IN'"></v-radio>
                <v-radio label="None" value="standard"></v-radio>
              </v-radio-group>
            </div>

            <!-- Reviewer Name radio buttons -->
            <div class="mt-4">
              <span class="font-weight-medium d-flex align-center">
                Reviewer Name:
                <!-- <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      small
                      color="grey"
                      class="ml-1"
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-information
                    </v-icon>
                  </template>
                  <span
                    >Please select reviewer name length you want in your reviews
                    replies</span
                  >
                </v-tooltip> -->
              </span>
              <v-radio-group
                v-model="selectedReviewerName"
                @change="updateReviewerName"
                row
              >
                <v-radio label="First Name" value="first"></v-radio>
                <v-radio label="Full Name" value="full"></v-radio>
              </v-radio-group>
            </div>
          </div>

          <v-checkbox
            v-if="autoRespond"
            v-model="autoRespondNegative.value"
            @change="updateNegativeRespond"
            label="Enable Auto Respond Negative Review"
          ></v-checkbox>

          <div
            v-if="autoRespondNegative.value"
            class="ml-4 border-l-2 border-gray-300 pl-2"
          >
            <span class="font-weight-medium">Negative Reply Type:</span>
            <v-radio-group
              v-model="autoRespondNegative.type"
              @change="updateNegativeRespond"
              row
            >
              <v-radio label="AI Generated Reply" value="ai"></v-radio>
              <v-radio label="Manual Reply" value="manual"></v-radio>
            </v-radio-group>
          </div>

          <div
            v-if="
              autoRespondNegative.value && autoRespondNegative.type === 'manual'
            "
            class="ml-4 border-l-2 border-gray-300 pl-2"
          >
            <v-textarea
              v-model="autoRespondNegative.reply"
              label="Type your reply..."
              outlined
              rows="2"
              dense
            ></v-textarea>
            <v-btn
              :disabled="!autoRespondNegative.reply"
              color="primary"
              @click="submitManualReply"
            >
              Submit
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <ResponseWordLimitSetting
      v-model="showResponseLimitDialog"
      @submitted="handleWordLimitSubmit"
    />
  </div>
</template>

<script>
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "@/utils/firebase.utils";
import ResponseWordLimitSetting from "@/components/reviews/ResponseWordLimit.vue";

export default {
  components: {
    ResponseWordLimitSetting,
  },
  data() {
    return {
      showActionsMenu: false,
      showWelcomePopup: false,
      autoRespond: false,
      showResponseLimitDialog: false,
      autoRespondNegative: {
        value: false,
        type: "",
        reply: "",
      },
      autoRespondStarRating: ["FIVE", "FOUR", "THREE"], // Default value
      selectedSalutation: "standard",
      selectedReviewerName: "first", // Default value for reviewer name
      country: "IN",
    };
  },
  methods: {
    async fetchAutoRespondStatus() {
      try {
        const workspaceRef = doc(
          db,
          "users",
          this.currentUID,
          "fly_workspaces",
          this.WID
        );
        const workspaceDoc = await getDoc(workspaceRef);
        if (workspaceDoc.exists()) {
          const workspaceData = workspaceDoc.data();
          this.autoRespond = workspaceData.gmb_auto_respond || false;
          this.autoRespondNegative = workspaceData.gmb_negative_respond || {
            value: false,
            type: "",
            reply: "",
          };
          this.autoRespondStarRating =
            workspaceData.auto_respond_star_rating || ["FIVE", "FOUR", "THREE"];
          this.selectedSalutation =
            workspaceData.gmb_auto_respond_salutation || "standard";
          this.selectedReviewerName =
            workspaceData.gmb_reviewer_name || "first";
          console.log(
            "status ",
            this.autoRespond,
            this.autoRespondNegative,
            this.autoRespondStarRating
          );
        }
      } catch (error) {
        console.error("Error fetching auto-respond status:", error);
      }
    },
    handleWordLimitSubmit(selectedRange) {
      // You can perform Firestore update here or pass the value to parent
      console.log("Selected Word Range:", selectedRange);
    },
    async updateAutoRespond() {
      try {
        const workspaceRef = doc(
          db,
          "users",
          this.currentUID,
          "fly_workspaces",
          this.WID
        );
        if (this.autoRespond) {
          await updateDoc(workspaceRef, {
            gmb_auto_respond: this.autoRespond,
            auto_respond_star_rating: this.autoRespondStarRating,
            gmb_auto_respond_salutation: this.selectedSalutation,
            gmb_reviewer_name: this.selectedReviewerName,
          });
        } else {
          await updateDoc(workspaceRef, {
            gmb_auto_respond: this.autoRespond,
            gmb_negative_respond: {
              value: false,
              reply: "",
              type: "",
            },
            gmb_auto_respond_salutation: "standard",
            gmb_reviewer_name: "first",
          });
          this.autoRespondNegative = {
            value: false,
            reply: "",
            type: "",
          };
          this.autoRespondStarRating = ["FIVE", "FOUR", "THREE"];
          this.selectedSalutation = "standard";
          this.selectedReviewerName = "first";
        }
        this.$snackbar.show(
          `Auto respond ${
            this.autoRespond ? "enabled" : "disabled"
          } successfully`
        );
      } catch (error) {
        console.error("Error updating auto respond setting:", error);
        this.$alert.show("Failed to update auto respond setting");
      }
    },
    async updateAutoRespondStarRating() {
      try {
        const workspaceRef = doc(
          db,
          "users",
          this.currentUID,
          "fly_workspaces",
          this.WID
        );
        if (this.autoRespondStarRating.length) {
          await updateDoc(workspaceRef, {
            auto_respond_star_rating: this.autoRespondStarRating,
          });
          this.$snackbar.show("Star rating preferences updated successfully");
        } else {
          this.autoRespond = false;
          await this.updateAutoRespond();
        }
      } catch (error) {
        console.error("Error updating star rating preferences:", error);
        this.$alert.show("Failed to update star rating preferences");
      }
    },
    async updateNegativeRespond() {
      try {
        const workspaceRef = doc(
          db,
          "users",
          this.currentUID,
          "fly_workspaces",
          this.WID
        );
        if (this.autoRespondNegative.value && this.autoRespondNegative.type) {
          this.autoRespondNegative.reply = "";
          await updateDoc(workspaceRef, {
            gmb_negative_respond: this.autoRespondNegative,
          });
          this.$snackbar.show(`AI Auto respond enabled`);
        } else {
          await updateDoc(workspaceRef, {
            gmb_negative_respond: {
              value: false,
              reply: "",
              type: "",
            },
          });
        }
      } catch (error) {
        console.error("Error updating negative respond setting:", error);
        this.$alert.show("Failed to update negative respond setting");
      }
    },
    async submitManualReply() {
      try {
        const workspaceRef = doc(
          db,
          "users",
          this.currentUID,
          "fly_workspaces",
          this.WID
        );
        await updateDoc(workspaceRef, {
          gmb_negative_respond: {
            value: true,
            reply: this.autoRespondNegative.reply,
            type: "manual",
          },
        });
        await this.closePopup();
        this.$snackbar.show("Manual reply submitted successfully");
      } catch (error) {
        console.log("error ", error);
        this.$alert.show("Failed to submit manual reply");
      }
    },
    closePopup() {
      this.showWelcomePopup = false;
    },
    async updateSalutations() {
      try {
        const workspaceRef = doc(
          db,
          "users",
          this.currentUID,
          "fly_workspaces",
          this.WID
        );
        await updateDoc(workspaceRef, {
          gmb_auto_respond_salutation: this.selectedSalutation,
        });
        this.$snackbar.show("Salutation preferences updated successfully");
      } catch (error) {
        console.error("Error updating salutation preferences:", error);
        this.$alert.show("Failed to update salutation preferences");
      }
    },
    async updateReviewerName() {
      try {
        const workspaceRef = doc(
          db,
          "users",
          this.currentUID,
          "fly_workspaces",
          this.WID
        );
        await updateDoc(workspaceRef, {
          gmb_reviewer_name: this.selectedReviewerName,
        });
        this.$snackbar.show("Reviewer name preferences updated successfully");
      } catch (error) {
        console.error("Error updating reviewer name preferences:", error);
        this.$alert.show("Failed to update reviewer name preferences");
      }
    },
    async fetchCountryCode() {
      const userRef = doc(db, "users", this.currentUID);
      const userDoc = await getDoc(userRef);
      if (userDoc.exists()) {
        const userDocData = userDoc.data();
        this.country = userDocData?.country_code || "IN";
      }
    },
  },
  mounted() {
    this.fetchCountryCode();
    this.fetchAutoRespondStatus();
  },
};
</script>

<style scoped>
.rotate-180 {
  transform: rotate(180deg);
}
</style>
